import axiosInstance from '../utils/axiosInstance';

export interface SetActiveJobRequest {
  jobId: string;
  jobType: string;
  status: 'PROCESSING' | 'COMPLETED' | 'FAILED';
  progress?: number;
  currentStep?: string;
}

export interface SetActiveJobResponse {
  success: boolean;
  message: string;
}

export const setUserActiveJob = async (jobData: SetActiveJobRequest): Promise<void> => {
  try {
    await axiosInstance.post<SetActiveJobResponse>('/user-jobs/active', jobData);
  } catch (error) {
    console.error('Failed to set active job:', error);
    throw error;
  }
};